import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ACTIONS } from 'src/app/global/models/dialog/dialog-data';
import { DialogDataThree, DialogDataThreeResult } from 'src/app/global/models/dialog/dialog-data-three';

@Component({
  selector: 'app-dialog-three-info',
  templateUrl: './dialog-three-info.component.html',
  styleUrls: ['./dialog-three-info.component.scss']
})
export class DialogThreeInfoComponent {

  constructor(
    public dialogRef: MatDialogRef<DialogThreeInfoComponent, DialogDataThreeResult>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataThree
  ) { }

  public firstAction() {
    this.closed(ACTIONS.CANCEL);
  }

  public secondAction() {
    this.closed(ACTIONS.OK);
  }

  private closed(action: ACTIONS) {
    this.dialogRef.close({
      action
    });
  }
}
